var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-4 flex flex-col rounded-lg",class:_vm.bgColor,on:{"click":_vm.close}},[_c('div',{staticClass:"py-2 px-4",class:_vm.textColor},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }